import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Link } from "react-router-dom";
import "../../../../utils/Css/employeelist.css";

import {
  getEmployeeDetails,
  updateEmployeePrime,
  updateFamilySituation,
} from "../../../../services/RHService/EmployeeService";
import { getPrimeByUser } from "../../../../services/RHService/PrimeService";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Button from "react-bootstrap/Button";
import withLoader from "../../../../components/layouts/WithLoader";

const EmployeeFolder = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();

  const location = useLocation();
  const id = localStorage.getItem("idEmployeFiche");
  const [fileData, setFileData] = useState(null);
  const [employeeDetail, setEmployeeDetail] = useState([]);
  useEffect(() => {
    startLoading();
    getEmployeeDetails(localStorage.getItem("idEmployeFiche"))
      .then((response) => {
        setEmployeeDetail(response.data.success);
        setFileData(response.data.success.fileUrl);
        stopLoading();
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);
  const [prime, setPrime] = useState([]);

  useEffect(() => {
    const fetchDataForPrime = async () => {
      const data = await getPrimeByUser(id);
      setPrime(data.success);
    };

    fetchDataForPrime().then(() => {
      stopLoading();
    });
  }, [id]);

  //update Primes
  const [inputList, setInputList] = useState([]);
  const [formDataInfo, setFormDataInfo] = useState({
    userPrimeModel: [],
  });
  useEffect(() => {
    if (prime.length > 0) {
      setInputList(
        prime
          .filter((c) => c.primeAmount !== null)
          .map((c) => ({ idPrime: c.idPrime, primeAmount: c.primeAmount }))
      );
    }
  }, []);
  const handleCheckboxChange = (index) => {
    const updatedPrime = prime.map((c, i) =>
      i === index ? { ...c, isAffected: !c.isAffected } : c
    );
    setPrime(updatedPrime);

    // Update inputList
    const updatedInputList = updatedPrime
      .filter((c) => c.isAffected && c.primeAmount !== "")
      .map((c) => ({ idPrime: c.idPrime, primeAmount: c.primeAmount }));

    // Include additional inputs
    if (
      updatedPrime[index].idPrime === "inputCheck" &&
      updatedPrime[index].isAffected
    ) {
      updatedInputList.push({ idPrime: "inputCheck", primeAmount: "" });
    }

    setInputList(updatedInputList);
  };

  const handlePrimeAmountChange = (event, index) => {
    const { value } = event.target;
    const updatedPrime = prime.map((c, i) =>
      i === index ? { ...c, primeAmount: value || "" } : c
    );

    setPrime(updatedPrime);

    // Update inputList
    const updatedInputList = updatedPrime
      .filter((c) => c.isAffected && c.primeAmount !== "")
      .map((c) => ({ idPrime: c.idPrime, primeAmount: c.primeAmount }));

    // Include additional inputs
    const additionalInputs = updatedPrime.filter(
      (c) => c.idPrime === "inputCheck" && c.isAffected
    );
    additionalInputs.forEach((input) => {
      updatedInputList.push({ idPrime: input.idPrime, primeAmount: "" });
    });

    setInputList(updatedInputList);
  };

  //set the formData by the inputList
  useEffect(() => {
    setFormDataInfo((prevState) => ({
      ...prevState,
      userPrimeModel: inputList,
    }));
  }, [inputList]);

  const handleUpdatePrime = async () => {
    if (formDataInfo !== null) {
      try {
        const updateSuccess = await updateEmployeePrime(
          id,
          formDataInfo.userPrimeModel
        );
        if (updateSuccess) {
          const { status, message } = updateSuccess;

          if (status === "success") {
            toastr.success(message);
          } else {
            toastr.error(message);
          }
        }
      } catch (error) {
        alert(error.message);
      }
    }
  };
  //end of update Primes

  const handleUpdateFamilySituation = async () => {
    console.log(employeeDetail);
    if (isNaN(employeeDetail.nbEnfantNonBoursier)) {
      toastr.error("Veuillez saisir le nombre d'enfant non boursier");
      return;
    }
    if (isNaN(employeeDetail.nbEnfantAcharge)) {
      toastr.error("Veillez saisir le nombre d'enfant à charge");
      return;
    }
    if (employeeDetail.nbEnfantAcharge === false) {
      employeeDetail.nbEnfantAcharge = 0;
    }
    if (employeeDetail.nbEnfantNonBoursier === false) {
      employeeDetail.nbEnfantNonBoursier = 0;
    }

    if (employeeDetail !== null) {
      try {
        const updateSuccess = await updateFamilySituation(id, employeeDetail);
        if (updateSuccess) {
          const { status, message } = updateSuccess;

          if (status === "success") {
            toastr.success(message);
          } else {
            toastr.error(message);
          }
        }
      } catch (error) {
        alert(error.message);
      }
    }
  };

  const goFicheEmployee = (idEmploye) => {
    localStorage.setItem("idEmployeFiche", idEmploye);
    const pdfWindow = window.open();
    pdfWindow.location.href = "/historiquefichedepaie";
    // navigate("/historiquefichedepaie");
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-4 col-md-4">
              <h1 className="m-0">Fiche Employé</h1>
            </div>

            <div className="col-sm-8 col-md-8">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <i class="fa-solid fa-house"></i>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to="/employeeList">Liste des personnels</Link>
                </li>
                <li className="breadcrumb-item active">Fiche Personnel</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              {/* Profile Image */}
              <div className="card card-primary card-outline">
                <div className="card-body box-profile">
                  <div className="text-center">
                    <img
                      class="profile-user-img img-fluid img-circle"
                      src="../../dist/img/téléchargement.png"
                      alt="User profile picture"
                    />{" "}
                  </div>
                  <h3 className="profile-username text-center">
                    {employeeDetail
                      ? employeeDetail.gender === "homme"
                        ? "Monsieur"
                        : "Madame"
                      : null}{" "}
                    {employeeDetail
                      ? employeeDetail.firstName + " " + employeeDetail.lastName
                      : ""}
                  </h3>
                  <p className="text-muted text-center">
                    {" "}
                    <strong className="center">
                      Numéro CNSS :
                      {employeeDetail ? employeeDetail.numCnss : ""}
                    </strong>
                  </p>
                  <ul className="list-group list-group-unbordered mb-3">
                    <li className="list-group-item">
                      <b>Email</b>{" "}
                      <a className="float-right">
                        {" "}
                        {employeeDetail ? employeeDetail.email : ""}
                      </a>
                    </li>
                    <li className="list-group-item">
                      <b>N° Téléphone</b>{" "}
                      <a className="float-right">
                        {employeeDetail ? employeeDetail.phone : ""}
                      </a>
                    </li>
                    <li className="list-group-item">
                      <b>CIN</b>{" "}
                      <a className="float-right">
                        {" "}
                        {employeeDetail ? employeeDetail.cin : ""}
                      </a>
                    </li>
                  </ul>
                  {/* <a href="#" className="btn btn-primary btn-block"><b>Follow</b></a> */}
                  <Button
                    className="btn btn-dark btn-block"
                    onClick={() => {
                      goFicheEmployee(id);
                    }}
                  >
                    Voir fiches de paie
                  </Button>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              <div className="card">
                <div className="card-header p-2">
                  <ul className="nav nav-pills">
                    <li className="nav-item">
                      <a
                        className="nav-link active"
                        href="#infoPersonnel"
                        data-toggle="tab"
                      >
                        Informations Personnels
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        href="#situationFam"
                        data-toggle="tab"
                      >
                        Situaltion Familiale
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="nav-link" href="#primes" data-toggle="tab">
                        Primes
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="card-body">
                  <div className="tab-content">
                    <div className="active tab-pane" id="infoPersonnel">
                      <div className="row">
                        <div className="col-md-4 mt-3">
                          <strong className="center">Date Recrutement</strong>
                          <br></br>
                          {employeeDetail ? employeeDetail.dateRec : ""}
                        </div>
                        <div className="col-md-4 mt-3">
                          <strong className="center">Date de naissance</strong>
                          <br></br>
                          {employeeDetail ? employeeDetail.dateNais : ""}
                        </div>
                        <div className="col-md-4 mt-3">
                          <strong className="center">Assurance vie</strong>
                          <br></br>
                          {employeeDetail && employeeDetail.isAssured ? (
                            <i className=" fa-solid fa-check"></i>
                          ) : (
                            <i className=" fa-solid fa-xmark"></i>
                          )}
                        </div>
                      </div>
                      <div class="row">
                        <div className="col-md-4">
                          <strong className="center">Pays </strong>
                          <br></br>
                          {employeeDetail ? employeeDetail.country : ""}
                        </div>

                        <div className="col-md-4">
                          <strong className="center">Adresse</strong>
                          <br></br>
                          {employeeDetail ? employeeDetail.adr : ""}
                        </div>
                        <div className="col-md-4">
                          <strong className="center">code Postal</strong>
                          <br></br>
                          {employeeDetail ? employeeDetail.postalCode : ""}
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="situationFam">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      className="custom-control-input"
                                      type="checkbox"
                                      id="customCheckbox1"
                                      defaultValue="option1"
                                      checked={
                                        employeeDetail &&
                                        employeeDetail.estChefDefamille
                                      }
                                      onChange={(e) =>
                                        setEmployeeDetail(
                                          (prevEmployeeDetail) => ({
                                            ...prevEmployeeDetail,
                                            estChefDefamille: e.target.checked,
                                          })
                                        )
                                      }
                                    />
                                    <label
                                      htmlFor="customCheckbox1"
                                      className="custom-control-label"
                                    >
                                      Est chef de famille
                                    </label>
                                  </div>
                                  <br />
                                  <div className="custom-control custom-checkbox">
                                    <input
                                      className="custom-control-input"
                                      type="checkbox"
                                      id="customCheckbox2"
                                      onChange={(e) =>
                                        setEmployeeDetail(
                                          (prevEmployeeDetail) => ({
                                            ...prevEmployeeDetail,
                                            nbEnfantAcharge: e.target.checked,
                                          })
                                        )
                                      }
                                      checked={
                                        employeeDetail &&
                                        employeeDetail.nbEnfantAcharge
                                      }
                                    />
                                    <label
                                      htmlFor="customCheckbox2"
                                      className="custom-control-label"
                                    >
                                      Enfant à charge (&lt;20 ans)
                                    </label>
                                  </div>
                                  <br />

                                  <div className="custom-control custom-checkbox">
                                    <input
                                      className="custom-control-input"
                                      type="checkbox"
                                      id="customCheckbox3"
                                      onChange={(e) =>
                                        setEmployeeDetail(
                                          (prevEmployeeDetail) => ({
                                            ...prevEmployeeDetail,
                                            nbEnfantNonBoursier:
                                              e.target.checked,
                                          })
                                        )
                                      }
                                      checked={
                                        employeeDetail &&
                                        employeeDetail.nbEnfantNonBoursier
                                      }
                                    />
                                    <label
                                      htmlFor="customCheckbox3"
                                      className="custom-control-label"
                                    >
                                      Enfant Non boursier
                                    </label>
                                  </div>
                                  <br />

                                  <div className="custom-control custom-checkbox">
                                    <input
                                      className="custom-control-input"
                                      type="checkbox"
                                      id="customCheckbox4"
                                      onChange={(e) =>
                                        setEmployeeDetail(
                                          (prevEmployeeDetail) => ({
                                            ...prevEmployeeDetail,
                                            estParentACharge: e.target.checked,
                                          })
                                        )
                                      }
                                      checked={
                                        employeeDetail &&
                                        employeeDetail.estParentACharge
                                      }
                                    />
                                    <label
                                      htmlFor="customCheckbox4"
                                      className="custom-control-label"
                                    >
                                      Parent à charge
                                    </label>
                                  </div>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <div className="col-md-12">
                                  <label>Nombre des enfants à charge</label>
                                  <input
                                    type="number"
                                    step="1"
                                    className="form-control"
                                    name="nbEnfantAcharge"
                                    placeholder="Nombre d'enfant à charge"
                                    value={
                                      employeeDetail
                                        ? employeeDetail.nbEnfantAcharge
                                        : 0
                                    }
                                    onChange={(e) =>
                                      setEmployeeDetail(
                                        (prevEmployeeDetail) => ({
                                          ...prevEmployeeDetail,
                                          nbEnfantAcharge: e.target.value,
                                        })
                                      )
                                    }
                                  />
                                </div>
                                <div className="col-md-12">
                                  <label>Nombre des enfants non boursier</label>
                                  <input
                                    type="number"
                                    step="1"
                                    className="form-control"
                                    name="nbEnfantNonBoursier"
                                    value={
                                      employeeDetail
                                        ? employeeDetail.nbEnfantNonBoursier
                                        : 0
                                    }
                                    onChange={(e) =>
                                      setEmployeeDetail(
                                        (prevEmployeeDetail) => ({
                                          ...prevEmployeeDetail,
                                          nbEnfantNonBoursier: e.target.value,
                                        })
                                      )
                                    }
                                    placeholder="Nombre d'enfant Non boursier"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-10"></div>

                            <div className="col-md-2">
                              <button
                                class="btn bg-black btn-sm float-right  "
                                onClick={() => {
                                  handleUpdateFamilySituation(id);
                                }}
                              >
                                Modifier la situaltion familiale
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="tab-pane" id="primes">
                      {prime.length !== 0 && (
                        <div>
                          {prime.map((c, index) => (
                            <div key={c.idPrime} className="row">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <div className="custom-control custom-checkbox">
                                      <input
                                        id={c.nomPrime}
                                        className="custom-control-input"
                                        type="checkbox"
                                        defaultValue="option1"
                                        value={c.idPrime}
                                        name="idPrime"
                                        checked={c.isAffected}
                                        onChange={() =>
                                          handleCheckboxChange(index)
                                        }
                                      />

                                      <label
                                        htmlFor={c.nomPrime}
                                        className="custom-control-label"
                                      >
                                        {c.nomPrime}
                                      </label>
                                    </div>
                                    <br />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <input
                                    type="text"
                                    className="form-control"
                                    onChange={(event) =>
                                      handlePrimeAmountChange(event, index)
                                    }
                                    name="primeAmount"
                                    value={c.primeAmount || ""}
                                    placeholder="Montant de Prime"
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-10"></div>

                        <div className="col-md-2">
                          <button
                            class="btn bg-black btn-sm float-right  "
                            onClick={() => {
                              handleUpdatePrime(id);
                            }}
                          >
                            Modifier Primes
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default withLoader(EmployeeFolder);
